import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getServiceTypes = createAsyncThunk(
  "provider/get-service-types",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BACKEND_URL}/provider/get-service-type`);
      return res.data.service_type;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch service types");
    }
  }
);

export const getProviderService = createAsyncThunk("provdier/list-services", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/list-services`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers service list");
  }
});

export const addProviderService = createAsyncThunk(
  "provider/add-service",
  async ({ token, serviceData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/provider/service-detail`,
        serviceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to add provider service"
      );
    }
  }
);

export const updateProviderService = createAsyncThunk(
  "provider/update-service",
  async ({ token, serviceId, serviceData }, thunkAPI) => {
    console.log("serviceId", serviceId);
    console.log("serviceData", serviceData);
    try {
      const res = await axios.post(
        `${BACKEND_URL}/provider/service-detail/${serviceId}`,
        serviceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update provider service"
      );
    }
  }
);

export const deleteProviderService = createAsyncThunk(
  "provider/delete-service",
  async ({ token, serviceId }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/provider/service-detail/${serviceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete provider service"
      );
    }
  }
);

const providerServiceSlice = createSlice({
  name: "providerService",
    initialState: {
      providersService: null,
      serviceTypes: [],
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderService.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderService.fulfilled, (state, action) => {
            state.providersService = action.payload;
            state.loading = false;
        })
        .addCase(getProviderService.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers service"; 
            state.loading = false;
        })
        .addCase(addProviderService.pending, (state) => {
          state.loading = true;
        })
        .addCase(addProviderService.fulfilled, (state, action) => {
          // Optional: push the new service to the existing state
          if (state.providersService?.service_type) {
            state.providersService.service_type.push(action.payload);
          }
          state.loading = false;
        })
        .addCase(addProviderService.rejected, (state, action) => {
          state.error = action.payload || "Failed to add provider service";
          state.loading = false;
        })
        .addCase(updateProviderService.pending, (state) => {
          state.loading = true;
        })
        .addCase(updateProviderService.fulfilled, (state, action) => {
          // Optional: push the new service to the existing state
          if (state.providersService?.service_type) {
            state.providersService.service_type.push(action.payload);
          }
          state.loading = false;
        })
        .addCase(updateProviderService.rejected, (state, action) => {
          state.error = action.payload || "Failed to update provider service";
          state.loading = false;
        })
        .addCase(deleteProviderService.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteProviderService.fulfilled, (state) => {
          state.loading = false;
        })
        .addCase(deleteProviderService.rejected, (state, action) => {
          state.error = action.payload || "Failed to delete provider service";
          state.loading = false;
        })
        .addCase(getServiceTypes.fulfilled, (state, action) => {
          state.serviceTypes = action.payload;
        })
        .addCase(getServiceTypes.rejected, (state, action) => {
          state.error = action.payload;
        })
      },
});

export default providerServiceSlice.reducer;